//дни открытых дверей
const btnOpDayColleges = document.getElementById('btnOpDayColleges');
const btnOpDayVuzes = document.getElementById('btnOpDayVuzes');

const tableColleges = document.getElementById('tableColleges');
const tableVuzes = document.getElementById('tableVuzes');

const filterMobDaysBtns = document.querySelectorAll('.btn__days');

//новости обрзования
const btnNewsEge = document.getElementById('btnNewsEge');
const btnNewsOther = document.getElementById('btnNewsOther');

const listNewsEge = document.getElementById('listNewsEge');
const listNewsOther = document.getElementById('listNewsOther');

const filterMobNewsBtns = document.querySelectorAll('.btn__news');


// новости образования

for(let i = 0; i < filterMobNewsBtns.length; i++) {

	filterMobNewsBtns[i].onclick = function() {
		for(let j = 0; j < filterMobNewsBtns.length; j++) filterMobNewsBtns[j].className = '';
		this.className = 'active';
	}
}

filterMobNewsBtns.forEach((btn, i) => {	
	btn.addEventListener('click', () => {

		if(btn === btnNewsEge) {
			listNewsEge.classList.add('show')
			listNewsOther.classList.remove('show')
		} else if(btn === btnNewsOther) {
			listNewsEge.classList.remove('show')
			listNewsOther.classList.add('show')
		}
	})
})


//дни открытых дверей
for(let i = 0; i < filterMobDaysBtns.length; i++) {
	filterMobDaysBtns[i].onclick = function() {
		filterMobDaysBtns[i].classList.toggle('active')
	}
}

filterMobDaysBtns.forEach((btn, i) => {
	
	btn.addEventListener('click', () => {
		if(btn.classList.contains('active')) {

			if(btn === btnOpDayColleges ) {
				tableColleges.classList.add('show')

			} else if(btn === btnOpDayVuzes) {
				tableVuzes.classList.add('show')
			}	

		} else {

			if(btn === btnOpDayColleges ) {
				tableColleges.classList.remove('show')

			} else if(btn === btnOpDayVuzes) {
				tableVuzes.classList.remove('show')
			}	
		}

		
	})
})